window.TeamLiveShiftOfferFinancialsApi = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['TeamLiveShiftOfferFinancials']);

    self.getUserShifts = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/users/working_days", "GET", params)
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    defer.resolve(res.data.data.users || []);
                } else {
                    defer.reject();
                }
            }, function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };
});